import type { ProductTier } from '../types/shared';

// Lowest to highest (backend `organizations.constants.TIER_ORDER`).
export const PRODUCT_TIERS: readonly ProductTier[] = [
  'basic',
  'business',
  'business_plus',
  'enterprise',
];

// Product names; they are not translated.
export const TIER_NAMES: Record<ProductTier, string> = {
  basic: 'Basic',
  business: 'Business',
  business_plus: 'Business+',
  enterprise: 'Enterprise',
};

// Billed monthly by invoice/SEPA instead of the prepaid wallet
// (backend `organizations.constants.POSTPAID_TIERS`).
const POSTPAID_TIERS: readonly ProductTier[] = ['business', 'business_plus', 'enterprise'];

export const isProductTier = (value: string | null): value is ProductTier =>
  PRODUCT_TIERS.includes(value as ProductTier);

export const isPostpaidTier = (tier: ProductTier): boolean => POSTPAID_TIERS.includes(tier);
